var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._l((_vm.list),function(item){return [_c('router-link',{key:item.id,attrs:{"tag":"section","to":"/guide/guidemap"}},[_c('van-image',{attrs:{"width":"100%","radius":"8","src":item.img}}),_c('p',[_vm._v(_vm._s(item.title))])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }